/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_UxInputs */

const en_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const ar_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تجربة_مستخدم`)
};

const bn_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const de_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const es_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const fr_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const pt_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const zh_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const tr_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const ru_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

const pl_svtag_ux = /** @type {(inputs: Svtag_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#UX`)
};

/**
* | output |
* | --- |
* | "#UX" |
*
* @param {Svtag_UxInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_ux = /** @type {((inputs?: Svtag_UxInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_UxInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_ux(inputs)
	if (locale === "bn") return bn_svtag_ux(inputs)
	if (locale === "de") return de_svtag_ux(inputs)
	if (locale === "es") return es_svtag_ux(inputs)
	if (locale === "fr") return fr_svtag_ux(inputs)
	if (locale === "pt") return pt_svtag_ux(inputs)
	if (locale === "zh") return zh_svtag_ux(inputs)
	if (locale === "tr") return tr_svtag_ux(inputs)
	if (locale === "ru") return ru_svtag_ux(inputs)
	if (locale === "pl") return pl_svtag_ux(inputs)
	return en_svtag_ux(inputs)
});